import { useState, useEffect, useRef, useCallback } from 'react';
import config from '@/config';
export var useRecaptcha = function (containerId, action, active) {
    var _a = useState(''), token = _a[0], setToken = _a[1];
    var widgetIdRef = useRef(null);
    var reset = useCallback(function () {
        var _a;
        setToken('');
        if (widgetIdRef.current !== null && ((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise)) {
            window.grecaptcha.enterprise.reset(widgetIdRef.current);
        }
    }, []);
    useEffect(function () {
        if (!active) {
            setToken('');
            widgetIdRef.current = null;
            return;
        }
        var timer = setTimeout(function () {
            var _a;
            if (!((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise))
                return;
            var container = document.getElementById(containerId);
            if (!container)
                return;
            if (widgetIdRef.current !== null) {
                window.grecaptcha.enterprise.reset(widgetIdRef.current);
            }
            else {
                widgetIdRef.current = window.grecaptcha.enterprise.render(containerId, {
                    sitekey: config.recaptchaKey,
                    action: action,
                    callback: setToken,
                });
            }
        }, 200);
        return function () { return clearTimeout(timer); };
    }, [active, containerId, action]);
    return { token: token, reset: reset };
};
